import * as Yup from 'yup';

/**
 * Same rules lead capture applies to the same fields — a malformed postal code or
 * a missing province is caught here rather than surfacing as a rejected order.
 */
export const manualAddressSchema = Yup.object({
  streetNumber: Yup.string().trim().required('A street number is required'),
  streetName: Yup.string().trim().required('A street name is required'),
  unitNumber: Yup.string(),
  city: Yup.string().trim().required('A city is required'),
  state: Yup.object().nullable().required('A province/state is required'),
  postalCode: Yup.string()
    .required('A postal/ZIP code is required')
    .matches(/^[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d$/i, 'Please enter a valid Canadian postal code (e.g. A1A 1A1)'),
});
